import { Button, Card, CardContent, CardHeader, Checkbox, FormControl, FormControlLabel, Grid2, LinearProgress, Typography } from "@mui/material";
import { NavigateNextIcon } from '@mui/icons-material/NavigateNext';
import { CheckBox } from "@mui/icons-material";
import { useState } from "react";

function Perhatian({ handleChange, data }) {
    return (
        <>
            <Card>
                <CardHeader title="Perhatian" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Typography variant="h5" component="div" sx={{ mb: 2 }}>
                        Sebelum mengisi formulir pendaftaran, mohon perhatikan hal-hal berikut:
                    </Typography>
                    <ul>
                        <li>Calon pendaftar diharapkan untuk membaca dan memahami mekanisme dan tahapan pendaftaran terlebih dahulu.</li>
                        <li>Formulir-formulir yang akan Anda isi terdiri dari beberapa bagian, sebisa mungkin semua kolom agar terisi.</li>
                        <li>Jisa satu bagian telah selesai, klik tombol Selanjutnya untuk lanjut ke bagian yang lain.</li>
                        <li>Harap diisi dengan data yang sebenarnya. Jika dikemudian hari calon santri diketahui tidak mengisi dengan data yang semestinya, maka dianggap gugur.</li>
                        <li>Apabila telah selesai, silahkan download dan cetak berkas yang ada di akhir langkah</li>
                    </ul>
                    <FormControlLabel sx={{ marginLeft: "10px" }} label="Ya, saya telah membaca dan memahaminya" control={<Checkbox required checked={(data?.agreement)} name="agreement" onChange={(e) => { handleChange(e.target.name, e.target.checked) }} sx={{ marginRight: "10px" }} />}></FormControlLabel>
                </CardContent>
            </Card>
        </>
    );
}

export default Perhatian;